import * as React from 'react';
import ArrowUpOutlined from './arrow-up-outlined';
import ArrowUpFilled from './arrow-up-filled';
import type { IconCombinedProps } from './types';
const ArrowUpCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowUpFilled ref={ref} {...rest} />;
  }
  return <ArrowUpOutlined ref={ref} {...rest} />;
});
export default ArrowUpCombined;